import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "utils/http";
import moment from "moment";
import { TRANSACTION } from "constants/api";

export interface ITransactionResponse extends ApiResponse {
  data: ITransactions;
}
export interface ITransactionsArgs extends ReduxAction {
  transactionType: TransactionType;
  page: number;
  queries: ITransactionSearchParams;
  dateQuerries: IDateRangePicker;
}

export interface IVerifyUserArgs extends ReduxAction {
  payload: { email: string };
}

export interface ICreateManualDepositArgs extends ReduxAction {
  payload: ICreateDeposit & { otp_code: string };
  uploadedFile: File;
}

export interface IMaunalTransferArgs extends ReduxAction {
  payload: ICreateTransfer & { otp_code: string };
}

export interface IVerifyUserResponse extends ApiResponse {
  data: IUser;
}

export const fetchTransactions = createAsyncThunk(
  TRANSACTION.LIST,
  async (
    {
      page,
      transactionType,
      queries,
      dateQuerries,
      onFailure,
    }: ITransactionsArgs,
    { rejectWithValue }
  ) => {
    try {
      const searchParams = new URLSearchParams();

      if (Object.values(queries)?.length) {
        Object.entries(queries).forEach(([key, value]) => {
          if (value) {
            searchParams.append(`${key}`, value);
          }
        });
      }

      if (dateQuerries?.from_date && dateQuerries?.to_date) {

        const startDate = moment(dateQuerries?.from_date).format('YYYY-MM-DD');
        const endDate = moment(dateQuerries?.to_date).format('YYYY-MM-DD');

        searchParams.append("from_date", startDate);
        searchParams.append("to_date", endDate);
      }

      const { data }: ITransactionResponse = await axios.get(
        `${TRANSACTION.LIST.replace(
          ":transactionType",
          String(transactionType)
        )}?page=${page}`,
        { params: searchParams }
      );
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const verifyUser = createAsyncThunk(
  TRANSACTION.VERIFY_USER,
  async (
    { payload, onSuccess, onFailure }: IVerifyUserArgs,
    { rejectWithValue }
  ) => {
    let response: IVerifyUserResponse;
    try {
      response = await axios.post(
        TRANSACTION.VERIFY_USER,
        payload
      );
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
    if (onSuccess) onSuccess(response.data);
    return response.data;
  }
);

export const createManualDeposit = createAsyncThunk(
  TRANSACTION.MANUAL_DEPOSIT,
  async (
    { payload, uploadedFile, onSuccess, onFailure }: ICreateManualDepositArgs,
    { rejectWithValue }
  ) => {
    let response: ApiResponse;
    try {
      const newPayload = { ...payload };
      delete newPayload.proof_of_payment;
      const formData = new FormData();
      for (const [key, value] of Object.entries(newPayload)) {
        if (value) {
          formData.append(`${key}`, value as unknown as any);
        }
      }
      formData.append("proof_of_payment", uploadedFile);

      response = await axios.post(
        TRANSACTION.MANUAL_DEPOSIT,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
    if (onSuccess) onSuccess(response.message);
    return response.message;
  }
);

export const updateTransationStatus = createAsyncThunk(
  TRANSACTION.UPDATE_STATUS,
  async (
    { id, statusType, payload, onSuccess, onFailure }: any,
    { rejectWithValue }
  ) => {
    let response: ApiResponse;
    try {
      response = await axios.post(
        TRANSACTION.UPDATE_STATUS.replace(":id", String(id)).replace(
          ":statusType",
          String(statusType)
        ),
        payload
      );
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
    if (onSuccess) onSuccess(response.message);
    return response.message;
  }
);

export const createManualTranfer = createAsyncThunk(
  TRANSACTION.MANUAL_DEBIT,
  async (
    { payload, onSuccess, onFailure }: IMaunalTransferArgs,
    { rejectWithValue }
  ) => {
    let response: ApiResponse;
    try {
      response = await axios.post(
        TRANSACTION.MANUAL_DEBIT,
        payload
      );
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
    if (onSuccess) onSuccess(response.message);
    return response.message;
  }
);
